import React from 'react';
import { Spinner } from 'react-bootstrap';
import classnames from 'classnames';
import styles from './searchView.module.scss';

const SearchSpinner = () => {
  return (
    <div
      className={classnames(
        'loadingIndicatorContainer fix-bg-images',
        styles.spinnerContainer
      )}
      data-testid="loading"
    >
      <Spinner animation="border" />
    </div>
  );
};

export default SearchSpinner;
